<template>
  <div id="tags-view-container" :class="['tags-view-container']">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper" @scroll="handleScroll">
      <router-link
        v-for="tag in visitedViews"
        ref="tag"
        :key="tag.name + tag.fullPath"
        :class="['tags-view-item']"
        :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
        tag="div"
        @click.middle.native="!isAffix(tag)?closeSelectedTag(tag):''"
        @contextmenu.prevent.native="openMenu(tag,$event)"
      >
        <div :class="['tags-box',  isActive(tag) ? 'active' : '']">
          <span class="title">{{ tag.title.includes("、") ? " " : tag.title }}</span>
          <span v-if="!isAffix(tag)" class="close-box" @click.prevent.stop="closeSelectedTag(tag)" >
            <i class="el-icon-close"></i>
          </span>
        </div>

      </router-link>
    </scroll-pane>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li v-if="selectedTag.fullPath === $route.fullPath" @click="refreshSelectedTag(selectedTag)">刷新页面</li>
      <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)">关闭页面</li>
      <li @click="closeOthersTags">关闭其他</li>
      <li @click="closeAllTags(selectedTag)">关闭所有</li>
    </ul>
  </div>
</template>

<script>
import ScrollPane from "./scrollPane"
import path from "path"
export default {
  components: { ScrollPane },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: []
    }
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    routes() {
      const router = this.$router.options.routes
      return router
    },
    setting() {
      return this.$store.state.setting
    }
  },
  watch: {
    $route() {
      this.addTags()
      this.moveToCurrentTag()
    },
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu)
      } else {
        document.body.removeEventListener("click", this.closeMenu)
      }
    }
  },
  mounted() {
    this.initTags()
    this.addTags()
  },
  methods: {
    isActive(route) {
      return route.fullPath === this.$route.fullPath
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix
    },
    filterAffixTags(routes, basePath = "/") {
      let tags = []
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          })
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
      })
      return tags
    },
    initTags() {
      const affixTags = this.affixTags = this.filterAffixTags(this.routes)
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name && tag.name !== "redirect") {
          this.$store.dispatch("tagsView/addVisitedView", tag)
        }
      }
    },
    addTags() {
      const { name } = this.$route
      if (name && !["redirect", "notFound"].includes(name)) {
        this.$store.dispatch("tagsView/addView", this.$route)
      }
      return false
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag)
            // when query is different then update
            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch("tagsView/updateVisitedView", this.$route)
            }
            break
          }
        }
      })
    },
    /**
     * @description: 刷新页面
     * @param {type} 
     * @return {type} 
     * @author: syx
     */
    refreshSelectedTag(view) {
      //原先代码，现已在路由拦截处做清除缓存  目的：解决点击侧边栏相同路由不刷新问题，现此次只需做跳转到重定向页面即可
      // this.$store.dispatch("tagsView/delCachedView", view).then(() => {
      //   const { fullPath } = view
      //   this.$nextTick(() => {
      //     this.$router.replace({ name: "redirect", params: { path: fullPath }})
      //   })
      // })

      //修改后的代码
      const { fullPath } = view
      this.$router.replace({ name: "redirect", params: { path: fullPath }})
    },
    closeSelectedTag(view) {
      this.$store.dispatch("tagsView/delView", view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag)
      this.$store.dispatch("tagsView/delOthersViews", this.selectedTag).then(() => {
        this.moveToCurrentTag()
      })
    },
    /**
     * @description: 删除所有 非 affix 的页面，并清除设置缓存的页面
     * @param {type} 
     * @return {type} 
     * @author: syx
     */
    closeAllTags(view) {
      this.$store.dispatch("tagsView/delAllViews").then(({ visitedViews }) => {
        if (this.affixTags.some(tag => tag.path === view.path)) {
          //解决在affix标签右键点击关闭所有时 非affix页面不切换的问题  当前路由不是非affix页面时跳转到该右键的页面
          if (this.$route.path !== view.path){
            this.$router.push(view.fullPath)
          }
          return
        }
        this.toLastView(visitedViews, view)
      })
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.fullPath)
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === "dashboard") {
          // to reload home page
          this.$router.replace({ path: "/redirect" + view.fullPath })
        } else {
          this.$router.push("/")
        }
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 15 // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }

      this.top = this.$el.offsetHeight
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    },
    handleScroll() {
      this.closeMenu()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-scrollbar__view{
  height: 100%;
  line-height: 0;
}
.tags-view-container {
  position: relative;
  height: $LayoutTagsHeight;
  width: 100%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
  // border: 1px solid #b6b7b9;
  background: #fff;
  .tags-view-wrapper {
    height: 100%;
    .tags-view-item {
      display: inline-block;
      position: relative;
      cursor: pointer;
      height: calc(100% - 10px);
      margin-top: 4px;
      margin-left: 5px;

      &:first-of-type {
        margin-left: 15px;
      }
      &:last-of-type {
        margin-right: 15px;
      }

      .tags-box{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 30px;
        border-radius: 4px;
        border: 1px solid #b6b7b9;
        color: #666666;
        background: #fff;
        font-size: 12px;
        padding-right: 8px;
        &.active {
          padding: 0 8px;
          border: 1px solid #b6b7b9;
          color: #fff;
          background: #008CFF;
        }
        &::before {
          content: '';
          display: inline-block;
          background: #fff;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          position: relative;
          margin-right: 2px;
        }

        .title {
          padding: 0 4px;
        }
      }
    }
  }
  .contextmenu {
    margin: 0;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    background-color: #fff;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        color: #008CFF;
        background: #eee;
      }
    }
  }
}
</style>

<style lang="scss">
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    .close-box{
      width: 16px;
      height: 16px; 
      border-radius: 50%;
      transition: all .3s cubic-bezier(.645, .045, .355, 1);
      transform-origin: 100% 50%;
      text-align: center;
      line-height: 16px;
      &:before {
        transform: scale(.6);
        display: inline-block;
      }
      &:hover {
        background-color: #b4bccc;
        color: #fff;
      }
      .el-icon-close {
        font-size: 12px;
      }
    }
  }
}
</style>
